import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@mui/material';

import ManageButton from '@/views/components/ManageButton/ManageButton';

const LetterContentSimplificationMenu = ({
	onAddAutoChanges,
	onAddAutoFixes,
	onClearAutoChanges,
	disabled,
	autoChanges,
}) => {
	const { dict, langNormalization } = useSelector((state) => state.app);
	const [ open, setOpen ] = useState(false);
	const anchorRef = useRef(null);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (
			anchorRef.current &&
            anchorRef.current.contains(event.target)
		) {
			return;
		}

		setOpen(false);
	};

	const handleAddChanges = (ev) => {
		onAddAutoChanges();
		handleClose(ev);
	};

	const handleAddFixes = (ev) => {
		onAddAutoFixes();
		handleClose(ev);
	};

	const handleClearChanges = (ev) => {
		onClearAutoChanges();
		handleClose(ev);
	};

	// const handleUse = (ev) => {
	// 	onUseTemplate && onUseTemplate(templateId);
	// 	handleClose(ev);
	// };

	const handleListKeyDown = (event) => {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		} else if (event.key === 'Escape') {
			setOpen(false);
		}
	};

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = useRef(open);
	useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}
		prevOpen.current = open;
	}, [ open ]);

	return (
		<>
			<ManageButton
				label={ dict.letter.contentSimplificationMenu.automaticSimplifications }
				forwardRef={ anchorRef } 
				open={ open }
				handleToggle={ handleToggle }
				disabled={ disabled }
			/>
			<Popper
				open={ open }
				anchorEl={ anchorRef.current }
				role={ undefined }
				placement='bottom-start'
				transition
				disablePortal
				className='mui__popper'
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{ ...TransitionProps }
						style={ {
							transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
						} }
					>
						<Paper>
							<ClickAwayListener onClickAway={ handleClose }>
								<MenuList
									autoFocusItem={ open }
									id='composition-menu'
									aria-labelledby='composition-button'
									onKeyDown={ handleListKeyDown }
								>
									<MenuItem
										className='table__menu-item'
										onClick={ handleAddChanges }
									>
										{ dict.letter.contentSimplificationMenu.inject }
									</MenuItem>
									{ langNormalization && <MenuItem
										className='table__menu-item'
										onClick={ handleAddFixes }
									>
										{ dict.letter.contentSimplificationMenu.correct }
									</MenuItem> }
									<MenuItem
										className='table__menu-item'
										onClick={ handleClearChanges }
										disabled={ autoChanges === 0 }
									>
										{ dict.letter.contentSimplificationMenu.removeAll }
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
					// eslint-disable-next-line indent
                )}
			</Popper>
		</>
	);
};

export default React.memo(LetterContentSimplificationMenu);